import { createRouter, createWebHistory } from 'vue-router'
import HomeView from "@/views/HomeView.vue";
import ProfessorsView from "@/views/ProfessorsView.vue";
import i18n from './i18n';
import ErrorView from "@/views/ErrorView.vue";
import ProfessorView from "@/views/ProfessorView.vue";
import OrganitzacionsView from "@/views/OrganitzacionsView.vue";
import AssignaturesView from "@/views/AssignaturesView.vue";
import TitulacionsView from "@/views/TitulacionsView.vue";
import MaterialsView from "@/views/MaterialsView.vue";
import TreballsFinalsView from "@/views/TreballsFinalsView.vue";
import AccesObertView from "@/views/AccesObertView.vue";
import VideosView from "@/views/VideosView.vue";
import ActivitatView from "@/views/ActivitatView.vue";
import CercarView from "@/views/CercarView.vue";
import OrganitzacioView from "@/views/OrganitzacioView.vue";
import AssignaturaView from "@/views/AssignaturaView.vue";
import TitulacioView from "@/views/TitulacioView.vue";
import ActivitatsView from "@/views/ActivitatsView.vue";
import InnovacioView from "@/views/InnovacioView.vue";
import PublishView from './views/PublishView.vue';
import Publish2View from './views/Publish2View.vue';
import NewsView from './views/NewsView.vue';
import ContactView from './views/ContactView.vue';
import AboutView from './views/AboutView.vue';



const routes = [
  {
    path: "/", redirect: `/${i18n.global.locale.value}`, name: "root"
  },

  {
    path: '/:locale(ca|es|en)',

    beforeEnter: (to, from, next) => {
      const locale = to.params.locale;
      if (i18n.global.availableLocales.includes(locale)) {
        i18n.global.locale.value = locale;
      }
      next();
    },
    children: [
      { path: '', component: HomeView, name: 'home' },

      { path: 'cerca', component: CercarView, name: 'cercar', query: 'q' },

      { path: 'professorat', redirect: `/${i18n.global.locale.value}/professorat/1/professor_nom_sort asc` },
      { path: 'professorat/list/:page/:sort', component: ProfessorsView, name: 'professorat' },
      { path: 'professorat/:id/:listPage?/:listSort?', component: ProfessorView, name: 'professor' },


      { path: 'organitzacions/list/:page/:sort', component: OrganitzacionsView, name: 'organitzacions' },
      { path: 'organitzacions/:id/:listPage?/:listSort?', component: OrganitzacioView, name: 'organitzacio' },

      { path: 'assignatures/list/:page/:sort', component: AssignaturesView, name: 'assignatures' },
      { path: 'assignatures/:id/:listPage?/:listSort?', component: AssignaturaView, name: 'assignatura' },
      {
        path: 'assignatures/:id/guia-docent/:curs',
        name: 'guiaDocent',
        component: () => import('./views/GuiaDocentView.vue')
      },
      {
        path: 'assignatures/:id/bibliografia/:curs',
        name: 'bibliografia',
        component: () => import('./views/BibliografiaRecomanadaView.vue')
      },

      { path: 'titulacions/list/:page/:sort', component: TitulacionsView, name: 'titulacions' },
      { path: 'titulacions/:id/:listPage?/:listSort?', component: TitulacioView, name: 'titulacio' },

      { path: 'activitats/:page?/:sort?', component: ActivitatsView, name: 'activitats' },
      { path: 'activitats/:id', component: ActivitatView, name: 'material' },

      { path: 'materials/:page?/:sort?', component: MaterialsView, name: 'materials' },

      { path: 'innovacio/:page?/:sort?', component: InnovacioView, name: 'innovacio' },

      { path: 'accesObert/:page?/:sort?', component: AccesObertView, name: 'accesObert' },

      { path: 'treballsFinals/:page/:sort', component: TreballsFinalsView, name: 'treballsFinals' },

      { path: 'videos/:page/:sort', component: VideosView, name: 'videos' },

      { path: 'cerca', component: CercarView, name: 'cercar' },

      { path: 'publish', component: Publish2View, name: 'publish' },
      { path: 'publish-v1', component: PublishView, name: 'publish-v1' },
      { path: 'news', component: NewsView, name: 'news' },
      { path: 'contact', component: ContactView, name: 'contact' },
      { path: 'about', component: AboutView, name: 'about' },


      { path: 'dummy-route', name: 'dummy-route', component: { template: '<div></div>' } },

    ]

  },

  { path: '/:pathMatch(.*)*', name: 'error', component: ErrorView },
]

const router = createRouter({
  history: createWebHistory(),
  //linkActiveClass: 'bg-active-upc',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }

    const bigPageChange = to.name !== from.name;
    if (bigPageChange) {
      return { top: 0, behavior: 'smooth' };
    }

    return false;
  }
})


export default router
